import { CoreInitiativesSonarObjectsName } from './name';
import { postInitiativeSonarObjects } from '@api';
import { refreshCurrentInitiativeSummarySaga } from '../summary/get';
import { updateSonarObjectReferences } from '../../sonar-objects/_idMap/actions';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesSonarObjectsPostAsyncSlice = createPostAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeSummarySaga,
			type: SagaYieldType.Every
		}
	],
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.SCOPE_CHANGED, ({ data }) => ({
				action: 'added',
				sonarObjectIds: data.sonarObjectIds
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences(
					request.sonarObjectIds.map((sonarObjectId) => ({
						initiatives: { toAdd: request.initiativeId },
						sonarObjectId
					}))
				)
		]
	},
	name: CoreInitiativesSonarObjectsName,
	receive: true,
	request: true,
	requestHandler: postInitiativeSonarObjects,
	yieldType: SagaYieldType.Every
});
